import { useMemo } from 'react';

import { GNB_HEIGHT_CSS_VAR } from '../utils/common/gnbHeight';
import { Z_INDEX } from '../utils/common/zIndex';
import { useIsPathname, useIsScrollGNB } from '../utils/hook/GNB';
import { useMySubscriptionsQuery } from '../utils/hook/react-query/useMySubscriptionsQuery';
import useMeQuery from '../utils/hook/react-query/user/useMeQuery';
import { useHistoryMethod } from '../utils/hook/useHistoryMethod';
import { usePathnameMethod } from '../utils/hook/usePathnameMethod';
import usePublishElementHeight from '../utils/hook/usePublishElementHeight';

import BandBanner from './BandBanner';
import NavbarCartButton from './NavbarCartButton';
import NavbarLoginButton from './NavbarLoginButton';
import NavbarStartButton from './NavbarStartButton';
import PCHeaderMenuList from './PCHeaderMenuList';
import PCHeaderRightButtons from './PCHeaderRightButtons';
import { SVG } from './SVG';

const PCHeader = () => {
  const { me } = useMeQuery();
  const { hasSubscriptions } = useMySubscriptionsQuery();
  const history = useHistoryMethod();
  const { pathname } = usePathnameMethod();
  const isScrollGNB = useIsScrollGNB();
  const isReferralReceivePage = useIsPathname('/referral/receive');
  const isCartPage = useIsPathname('/cart');

  /** GNB 행 높이(스크롤 중 불변) → CSS 변수(GNB_HEIGHT_CSS_VAR)로 발행, sticky 서브헤더 top·오프셋이 구독 */
  const gnbRowRef = usePublishElementHeight(GNB_HEIGHT_CSS_VAR, {
    skipZero: true,
  });

  const onClickMainPage = () => {
    if (pathname === '/main') return;

    history.push('/main');
  };

  const rightSideButton = useMemo(() => {
    if (isScrollGNB) return <NavbarStartButton />;

    if (!me) {
      return (
        <div className="flex items-center gap-12px">
          {!isCartPage && <NavbarCartButton />}
          {!isReferralReceivePage && <NavbarLoginButton />}
        </div>
      );
    }
    return (
      <PCHeaderRightButtons
        isCartPage={isCartPage}
        hasSubscriptions={hasSubscriptions}
      />
    );
  }, [me, isScrollGNB, isCartPage, isReferralReceivePage, hasSubscriptions]);

  return (
    // display:contents로 띠배너·GNB를 부모 flex 기둥의 직접 flex item으로 올려 sticky containing block을 확보한다
    <div className="hidden sm:contents">
      {/* 띠배너: 흐름 안에 두어 스크롤 시 자연히 위로 사라진다 (수동 spacer 불필요) */}
      <BandBanner />
      {/* GNB 행: sticky로 상단 고정. 흐름 안이므로 브라우저가 높이만큼 공간을 자동 예약한다 */}
      <div
        ref={gnbRowRef}
        className="sticky top-0 w-full bg-white"
        style={{ zIndex: Z_INDEX.PC_GNB }}
      >
        <div className="mx-auto flex max-w-screen-lg justify-between px-3 py-[13px]">
          <div className="flex items-center gap-[36px]">
            <button onClick={onClickMainPage} type="button">
              <SVG.Logo />
            </button>
            <PCHeaderMenuList />
          </div>
          {rightSideButton}
        </div>
      </div>
    </div>
  );
};

export default PCHeader;
